import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import CaseStudies from './case-studies';
import Technologies from './tehnologies';
import DeepDives from './deep-dives';
import Services  from './services';
import GetInTouch from './get-in-touch';
import ReactToAmplify from './deep-dives/react-to-amplify';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from './home';
import GoLangWebAppEcr from './deep-dives/golang-webapp-ecr';
import GoLangWebAppCors from './deep-dives/golang-webapp-cors';
import GoLangWebAppDynamo from './deep-dives/golang-webapp-dynamo';
import GoLangWebAppArchitecture from './deep-dives/golang-webapp-architecture';
import Cloud9 from './deep-dives/cloud9';
import Analytics from "./analytics";


export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="*" element={<HomePage />} />
                <Route path="/case-studies" element={<CaseStudies />} />
                <Route path="/deep-dives" element={<DeepDives />} />
                <Route path="/services" element={<Services />} />
                <Route path="/tehnologies" element={<Technologies />} />
                <Route path="/get-in-touch" element={<GetInTouch />} />
                <Route path="/dp-dv-react-to-aws" element={<ReactToAmplify />} />
                <Route path="/dp-golang-webapp-ecr" element={<GoLangWebAppEcr />} />
                <Route path="/dp-golang-webapp-cors" element={<GoLangWebAppCors />} />
                <Route path="/dp-golang-webapp-dynamodb" element={<GoLangWebAppDynamo />} />
                <Route path="/dp-golang-webapp-architecture" element={<GoLangWebAppArchitecture />} />
                <Route path="/cloud" element={<Cloud9 />} />
                <Route path="/analytics" element={<Analytics />} />
            </Routes>
        </BrowserRouter>
    )
}

ReactDOM.render(

    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
